import React, { useState, useEffect } from 'react'
import Buttons from '../../../../components/UI/Buttons';
import Button from '../../../../components/UI/Buttons/Button';
import { Modal } from 'react-bootstrap';
import FormInputs from '../../../../components/UI/FormInputs';

const SendMail = (props) => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [includePmh, setIncludePmh] = useState(false);
  const [includeDemographics, setIncludeDemographics] = useState(false);

  useEffect(() => {
    if (props.isopen) {
      setIncludePmh(props.initialIncludePmh === true);
      setIncludeDemographics(props.initialIncludeDemographics === true);
    }
  }, [props.isopen, props.initialIncludePmh, props.initialIncludeDemographics]);

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleEmailChange = (value) => {
    const nextValue =
      typeof value === 'string' ? value : value?.target?.value ?? '';
    setEmail(nextValue);
    if (error) {
      setError('');
    }
  };

  const handleSend = () => {
    if (!email.trim()) {
      setError('Email is required');
      return;
    }
    if (!validateEmail(email)) {
      setError('Please enter a valid email address');
      return;
    }
    props.onSendEmail(email, { includePmh, includeDemographics });
  };

  const handleClose = () => {
    setEmail('');
    setError('');
    props.onClose();
  };

  return (
     <Modal
        show={props.isopen}
        onHide={handleClose}
        dialogClassName="hResponsive"
        centered
        keyboard={false}
        backdrop="static"
      >
        <div className="sh_modalBox">
          <Modal.Header closeButton>
            <Modal.Title>
              <h6 className="text-lg mb-0 font-weight-bold">{"Send Email"}</h6>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="form-group mb-3">
              <label htmlFor="emailInput" className="form-label">Email Id <span className="text-danger">*</span></label>
              <FormInputs
                type="TextInput"
                name="email"
                placeholder="Enter email address"
                value={email}
                changeHandler={handleEmailChange}
              />
              {error && (
                <div className="text-danger mt-1" style={{ fontSize: '12px' }}>
                  {error}
                </div>
              )}
            </div>
            <div className="form-group">
              <div className="form-check mb-2">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="sendMailIncludePmh"
                  checked={includePmh}
                  onChange={(e) => setIncludePmh(e.target.checked)}
                />
                <label className="form-check-label" htmlFor="sendMailIncludePmh">
                  Include PMH
                </label>
              </div>
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="sendMailIncludeDemographics"
                  checked={includeDemographics}
                  onChange={(e) => setIncludeDemographics(e.target.checked)}
                />
                <label className="form-check-label" htmlFor="sendMailIncludeDemographics">
                  Include Patient Demographics
                </label>
              </div>
            </div>
          </Modal.Body>

          <Modal.Footer className="d-flex justify-content-center">
               <Buttons
                className="btn btn-secondary sh_btnsecondary mr-2"
                clickHandler={handleClose}
                label="Cancel"
              />
            <Buttons
                className="btn btn-primary sh_btnprimary mr-2"
                clickHandler={handleSend}
                label="Send"
              />
          </Modal.Footer>
        </div>
      </Modal>
  )
}

export default SendMail